import axios from 'axios';
import { LOCAL_STORAGE_USER } from '../configs/constants';

axios.defaults.withCredentials = true;

export const deleteData = async (submitUrl) => {
    let path = submitUrl.charAt(0) === '/' ? submitUrl : `/${submitUrl}`;

    const url = process.env.REACT_APP_CMS_API_PATH + path;
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    const token = user.accessToken;

    return await axios({ url, method: 'DELETE', headers: {
        'Authorization': `Bearer ${token}`
    } });
};
